import { Conversation } from "@twilio/conversations";

export const isConversationClosed = (conversation?: Conversation) => conversation?.state?.current === "closed";

export const isCurrentParticipantInConversation = (
    participants: { identity?: string | null }[] = [],
    currentUserIdentity?: string | null
) => {
    if (!currentUserIdentity) {
        return false;
    }

    return participants.some((participant) => participant.identity === currentUserIdentity);
};
